module.exports = __webpack_public_path__ + "img/home-list-test.12301c4f.png";